import { PageBlockColorV2, PageBlockDefinition, PageBlockDefinitionBehavior, PageBlockDefinitionItem, PageBlockDefinitionLayout, PageBlockDefinitionProperty, PageBlockDefinitionVariant, } from "@supernova-studio/model";
export const DTOPageBlockDefinitionBehavior = PageBlockDefinitionBehavior;
export const DTOPageBlockDefinitionItem = PageBlockDefinitionItem;
export const DTOPageBlockDefinitionLayout = PageBlockDefinitionLayout;
export const DTOPageBlockDefinitionVariant = PageBlockDefinitionVariant;
export const DTOPageBlockDefinitionProperty = PageBlockDefinitionProperty;
export const DTOPageBlockColorV2 = PageBlockColorV2;
export const DTOPageBlockDefinition = PageBlockDefinition;
